<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Booking request</v-toolbar-title>
    </v-toolbar>
  </v-card>
</template>

<script>
import { Database } from '@/library/firebase'

export default {
  data () {
    return {
      request: {},
      userid: this.$route.params.uid,
      id: this.$route.params.id
    }
  },
  methods: {
    getRequest () {
      Database.ref('bookingRequests').child(this.userid).child(this.id).once('value', data => {
        this.request = data.val()
      }).catch(e => {
        console.error(e)
      })
    }
  },
  created () {
    this.getRequest()
  }
}
</script>

<style>
</style>
